"use client"

import classNames from "classnames"
import PropTypes from "prop-types"

import { BaseParagraph } from "./styled"

/** This component renders a paragraph with variable font-size and color */
export const Paragraph = ({
  xl = false,
  large = false,
  small = false,
  xs = false,
  h2 = false,
  bold = false,
  success = false,
  warning = false,
  danger = false,
  highlight = false,
  dimmed = false,
  alert = false,
  accent = false,
  marginBottom = false,
  marginTop = false,
  marginLeft = false,
  uppercase = false,
  textAlign = "left",
  text = "",
  children,
  ...props
}) => {
  return (
    <BaseParagraph
      $size={classNames({ xl }, { large }, { small }, { xs }, { h2 })}
      $color={classNames({ success }, { warning }, { danger }, { highlight }, { dimmed }, { alert }, { accent })}
      $bold={bold}
      $marginBottom={marginBottom}
      $marginTop={marginTop}
      $marginLeft={marginLeft}
      $transform={uppercase}
      $textAlign={textAlign}
      {...props}
    >
      {!children && text}
      {children}
    </BaseParagraph>
  )
}

Paragraph.propTypes = {
  /** If true, the font size will be extra large */
  xl: PropTypes.bool,
  /** If true, the font size will be larger */
  large: PropTypes.bool,
  /** If true, the font size will be smaller */
  small: PropTypes.bool,
  /** If true, the font size will be extra small */
  xs: PropTypes.bool,
  /** If true, the text is displayed like an h2 headline */
  h2: PropTypes.bool,
  /** If true, the font size will be bold */
  bold: PropTypes.bool,
  /** If true, the font color will be success.bg */
  success: PropTypes.bool,
  /** If true, the font size will be warning.bg */
  warning: PropTypes.bool,
  /** If true, the font size will be danger.bg */
  danger: PropTypes.bool,
  /** If true, the font size will be highlight.bg */
  highlight: PropTypes.bool,
  /** If true, the font size will be dimmed.bg */
  dimmed: PropTypes.bool,
  /** If true, the font size will be alert.bg */
  alert: PropTypes.bool,
  /** If true, the font color will be accent.bg */
  accent: PropTypes.bool,
  /** If false, there is no space to the next element */
  marginBottom: PropTypes.bool,
  /** If true, the text is displayed uppercase */
  uppercase: PropTypes.bool,
  /** Defines the text alignment */
  textAlign: PropTypes.oneOf(["left", "center", "right", "justify"]),
  /** Defines the text for the paragraph (required) */
  text: PropTypes.any,
}
